export default "__VITE_ASSET__CcAC0VVw__"